<div class="dialog-header header-simple">
  <h2 mat-dialog-title>
    {{ 'createDoc.createDocDialog.title' | transloco }}
  </h2>
  <button mat-icon-button color="primary" (click)="onCancel()" type="button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form [formGroup]="form">
  <mat-dialog-content>
    <section class="section">
      <label class="field-label">
        {{ 'createDoc.createDocDialog.producerLabel' | transloco }}
        <span class="required">*</span>
      </label>
      <div class="field-wrapper">
        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            formControlName="manufacturer"
            [matAutocomplete]="manufacturerAuto"
            [placeholder]="'common.buttons.search' | transloco"
          />
          <mat-autocomplete #manufacturerAuto="matAutocomplete" [displayWith]="displayCompany">
            <mat-option *ngFor="let c of filteredManufacturers" [value]="c">
              {{ c.companyName }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="form.get('manufacturer')?.hasError('required')">
            {{ 'createDoc.createDocDialog.manufacturerRequired' | transloco }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="info-hint">
        <mat-icon color="primary" inline>info</mat-icon>
        @if (canManageProfiles) {
          <span>
            {{ 'createDoc.createDocDialog.producerHintPre' | transloco }}
            <a (click)="clickOrganisationSettings()">
              {{ 'createDoc.createDocDialog.producerHintLink' | transloco }}
            </a>
            {{ 'createDoc.createDocDialog.producerHintPost' | transloco }}
          </span>
        } @else {
          <span>{{ 'createDoc.createDocDialog.profilesManagedByAdmin' | transloco }}</span>
        }
      </div>
      <div *ngIf="selectedManufacturer" class="company-card">
        <div class="company-icon">
          <mat-icon>apartment</mat-icon>
        </div>
        <div class="company-details">
          <div class="company-name">{{ selectedManufacturer.companyName }}</div>
          <div>
            {{ selectedManufacturer.address }},
            {{ selectedManufacturer.postCode }}
            {{ selectedManufacturer.city }},
            {{ getCountryName(selectedManufacturer.location) }}
          </div>
        </div>
      </div>
      <div *ngIf="!selectedManufacturer" class="company-card empty-card">
        <div class="company-icon warn">
          <mat-icon>warning</mat-icon>
        </div>
        <div class="company-details">
          <div class="company-name">{{ 'createDoc.createDocDialog.noManufacturerSelected' | transloco }}</div>
        </div>
      </div>

      <label class="field-label">
        {{ 'createDoc.createDocDialog.docProfileLabel' | transloco }}
      </label>
      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
        <mat-select formControlName="docProfileId">
          <mat-option [value]="noDocProfileId">{{ 'createDoc.createDocDialog.docProfileNone' | transloco }}</mat-option>
          <mat-option *ngFor="let profile of docProfiles" [value]="profile.id">{{ profile.profileName }}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="info-hint">
        <mat-icon color="primary" inline>info</mat-icon>
        <span>
          {{ 'createDoc.createDocDialog.docProfileHintPre' | transloco }}
          <a (click)="clickPpwrProfiles()">
            {{ 'createDoc.createDocDialog.docProfileHintLink' | transloco }}
          </a>
          {{ 'createDoc.createDocDialog.docProfileHintPost' | transloco }}
        </span>
      </div>
    </section>

    <section class="section">
      <div class="section-header">
        <div>
          <h3 class="section-title">
            {{ 'createDoc.createDocDialog.representativeTitle' | transloco }}
          </h3>
          <p class="section-subtitle">
            {{ 'createDoc.createDocDialog.representativeSubtitle' | transloco }}
          </p>
        </div>
        <mat-slide-toggle formControlName="hasRepresentative" color="primary"> </mat-slide-toggle>
      </div>
      <ng-container *ngIf="form.value.hasRepresentative">
        <label class="field-label">
          {{ 'createDoc.createDocDialog.representativeLabel' | transloco }}
        </label>
        <div class="field-wrapper">
          <mat-form-field appearance="outline" class="full-width">
            <mat-icon matPrefix>search</mat-icon>
            <input
              matInput
              formControlName="representative"
              [matAutocomplete]="representativeAuto"
              [placeholder]="'common.buttons.search' | transloco"
            />
            <mat-autocomplete #representativeAuto="matAutocomplete" [displayWith]="displayCompany">
              <mat-option *ngFor="let c of filteredRepresentatives" [value]="c">
                {{ c.companyName }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="form.get('representative')?.hasError('required')">
              {{ 'dataManagement.organizationSettings.validation.representativeRequired' | transloco }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="info-hint">
          <mat-icon color="primary" inline>info</mat-icon>
          @if (canManageProfiles) {
            <span>
              {{ 'createDoc.createDocDialog.representativeHintPre' | transloco }}
              <a (click)="clickOrganisationSettings()">
                {{ 'createDoc.createDocDialog.representativeHintLink' | transloco }}
              </a>
              {{ 'createDoc.createDocDialog.representativeHintPost' | transloco }}
            </span>
          } @else {
            <span>{{ 'createDoc.createDocDialog.profilesManagedByAdmin' | transloco }}</span>
          }
        </div>
        <div *ngIf="selectedRepresentative" class="company-card">
          <div class="company-icon">
            <mat-icon>handshake</mat-icon>
          </div>
          <div class="company-details">
            <div class="company-name">{{ selectedRepresentative.companyName }}</div>
            <div>
              {{ selectedRepresentative.address }},
              {{ selectedRepresentative.postCode }}
              {{ selectedRepresentative.city }},
              {{ getCountryName(selectedRepresentative.location) }}
            </div>
          </div>
        </div>
        <div *ngIf="!selectedRepresentative" class="company-card empty-card">
          <div class="company-icon warn">
            <mat-icon>warning</mat-icon>
          </div>
          <div class="company-details">
            <div class="company-name">{{ 'createDoc.createDocDialog.noRepresentativeSelected' | transloco }}</div>
          </div>
        </div>
      </ng-container>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-stroked-button type="button" (click)="onCancel()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="onContinue()">
      {{ 'common.buttons.confirm' | transloco }}
    </button>
  </mat-dialog-actions>
</form>
